const PDFJS_EXPRESS_KEY = process.env.REACT_APP_PDFJS_EXPRESS_KEY
const PDFJS_EXPRESS_PATH = process.env.REACT_APP_PDFJS_EXPRESS_PATH
export { PDFJS_EXPRESS_KEY, PDFJS_EXPRESS_PATH }
